// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-body {
  min-height: 50vh;
}

.tabs {
  padding: 0.5rem 0rem;
  margin-bottom: 0rem !important;
}
.tabs ul {
  border-bottom-width: 0px !important;
}
.tabs .doc-views-tabs li.is-active {
  border-bottom: 1px solid var(--primaryColor) !important;
}
.tabs li.tab {
  margin-bottom: 0.5em !important;
}

.tabs.is-boxed a {
  border: none !important;
}

::ng-deep .angular-editor-textarea, ::ng-deep .p-editor-container {
  background: #fff !important;
}

.library_tile_view {
  padding: 0px 0px 7px 0px !important;
}
.library_tile_view .has-tooltip-top,
.library_tile_view .has-tooltip-right,
.library_tile_view .has-tooltip-left,
.library_tile_view .has-tooltip-bottom {
  position: relative;
}
.library_tile_view .has-tooltip-top::before, .library_tile_view .has-tooltip-top::after,
.library_tile_view .has-tooltip-right::before,
.library_tile_view .has-tooltip-right::after,
.library_tile_view .has-tooltip-left::before,
.library_tile_view .has-tooltip-left::after,
.library_tile_view .has-tooltip-bottom::before,
.library_tile_view .has-tooltip-bottom::after {
  z-index: 50 !important;
}
.library_tile_view .drag-drop-container {
  position: relative;
  overflow: visible;
}
.library_tile_view .drag-drop-container .card {
  position: relative;
  overflow: visible;
}
.library_tile_view .drag-drop-container .card .dropdown-content {
  padding: 0px !important;
  z-index: 999;
  position: absolute;
}
.library_tile_view .drag-drop-container .card .dropdown-content .dropdown-item:hover {
  background-color: #e7e7e7 !important;
}
.library_tile_view .drag-drop-container .card .dropdown-content .dropdown-divider {
  margin: 0px !important;
}
.library_tile_view .drag-drop-container .card .tools {
  margin-top: 5px !important;
}
.library_tile_view .tabs.stepper li a, .library_tile_view .tabs.stepper li.is-active a {
  border: none !important;
}
.library_tile_view .tabs:not(.stepper) li span {
  display: none;
}
.library_tile_view .tabs.stepper {
  padding: 0.3rem 5rem !important;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;
}
.library_tile_view .tabs.stepper li {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-right: 10px;
}
.library_tile_view .tabs.stepper li a {
  padding: 0px 5px 0px 5px;
}
.library_tile_view .tabs.stepper li span.check-mark, .library_tile_view .tabs.stepper li span.edit {
  display: none;
}
.library_tile_view .tabs.stepper li.is-active {
  opacity: 1;
}
.library_tile_view .tabs.stepper li.is-active span:not(.line-horizontal) {
  background: var(--primaryColor) !important;
}
.library_tile_view .tabs.stepper li.is-active a {
  color: var(--primaryColor) !important;
}
.library_tile_view .tabs.stepper li.is-active span {
  display: none;
}
.library_tile_view .tabs.stepper li.is-active span.line-horizontal {
  display: inline-block;
}
.library_tile_view .tabs.stepper li.is-active span.edit {
  display: inline-block;
}
.library_tile_view .tabs.stepper li.complete {
  opacity: 1;
}
.library_tile_view .tabs.stepper li.complete span {
  background: #3BBFA1 !important;
}
.library_tile_view .tabs.stepper li.complete span {
  display: none;
}
.library_tile_view .tabs.stepper li.complete span.line-horizontal {
  display: inline-block;
}
.library_tile_view .tabs.stepper li.complete span.check-mark {
  display: inline-block;
  background: #3BBFA1 !important;
  color: #fff !important;
}
.library_tile_view .tabs.stepper li.complete span.line-horizontal {
  border: 1px solid #3BBFA1 !important;
}
.library_tile_view .tabs.stepper li.complete a {
  color: #3BBFA1 !important;
}
.library_tile_view .tabs.stepper li span:not(.line-horizontal) {
  background: #626262;
  text-align: center;
  padding: 3px 10px;
  color: #fffdfd;
  border-radius: 100%;
}
.library_tile_view .tabs.stepper li span.line-horizontal {
  border: 1px solid var(--primaryColor) !important;
  width: 100%;
  margin-top: 5px;
}
.library_tile_view .input {
  height: 2rem !important;
  font-size: 0.9rem !important;
}
.library_tile_view .questionnarie {
  width: 97%;
  margin: 1% auto;
  background: #fafafa !important;
}
.library_tile_view .questionnarie .has-text-danger {
  font-size: 0.9rem !important;
}
.library_tile_view .questionnarie .input {
  width: 100% !important;
}
.library_tile_view .questionnarie .pi-trash, .library_tile_view .questionnarie .pi-trash:hover {
  color: #f14668 !important;
}
.library_tile_view .questionnarie .icon {
  margin-left: 10px;
}
.library_tile_view .question-option .has-text-danger {
  font-size: 0.9rem !important;
}
.library_tile_view .question-option .radio-group {
  width: 0px !important;
}
.library_tile_view .question-option .input {
  width: 100% !important;
}
.library_tile_view .question-option .icon {
  margin-left: 10px;
}
.library_tile_view .question-option .pi-trash, .library_tile_view .question-option .pi-trash:hover {
  color: #f14668 !important;
}
.library_tile_view .question-option .is-checkradio[type=radio] + label, .library_tile_view .question-option .is-checkradio[type=checkbox] + label {
  padding: 0.2rem 0.8rem !important;
}
.library_tile_view .flex-container .flex-item .card {
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  position: relative;
  overflow: visible;
  z-index: 1;
  padding: 0.5rem;
}
.library_tile_view .flex-container .flex-item .card .title {
  margin-bottom: 0.2rem;
  width: 100%;
}
.library_tile_view .flex-container .flex-item .card .title, .library_tile_view .flex-container .flex-item .card .shared {
  cursor: pointer;
}
.library_tile_view .flex-container .flex-item .card .title, .library_tile_view .flex-container .flex-item .card label {
  font-size: 0.9rem;
}
.library_tile_view .flex-container .flex-item .card .shared, .library_tile_view .flex-container .flex-item .card .subtitle {
  color: #a1a1a1;
}
.library_tile_view .flex-container .flex-item .card:hover {
  cursor: pointer;
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.12);
  border-color: var(--primaryColor);
  z-index: 5;
}
.library_tile_view .flex-container .flex-item .card:hover .button {
  box-shadow: none;
}
.library_tile_view .flex-container .flex-item .card:hover .shareBtnOptions {
  display: block !important;
}
.library_tile_view .flex-container .flex-item .card:hover .fileBtnOptions {
  display: block !important;
}
.library_tile_view .flex-container .flex-item .card:hover .buylesson {
  display: block !important;
}
.library_tile_view .flex-container .flex-item .card .card-image {
  cursor: pointer;
  object-fit: contain;
}
.library_tile_view .flex-container .flex-item .card .card-image .thumb_play {
  position: absolute;
  top: 48%;
  left: 45%;
  display: none;
}
.library_tile_view .flex-container .flex-item .card .card-image .thumb_play .fa {
  color: #dcdcdc;
  font-size: 32px !important;
}
.library_tile_view .flex-container .flex-item .card .card-image .lesson_image {
  padding: 5px;
}
.library_tile_view .flex-container .flex-item .card .card-image .tile_imgcenter {
  height: auto;
  display: block;
  width: 100%;
  padding: 10px;
  object-fit: contain;
  height: 146px;
}
.library_tile_view .flex-container .flex-item .card .card-image .videoDuration {
  font-size: 12px;
  position: absolute;
  right: 5px;
  font-weight: 600;
  background: #333;
  color: var(--whiteColor);
  bottom: 10px;
  width: 59px;
  text-align: center;
}
.library_tile_view .flex-container .flex-item .card .card-content, .library_tile_view .flex-container .flex-item .card .card-body {
  cursor: default !important;
  padding: 0.75rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnaries, .library_tile_view .flex-container .flex-item .card .card-body .questionnaries {
  border-left: 1px solid #acacac;
}
.library_tile_view .flex-container .flex-item .card .card-content .is-divider-vertical, .library_tile_view .flex-container .flex-item .card .card-body .is-divider-vertical {
  display: flex;
  flex: none;
  width: auto;
  height: auto;
  padding: 2rem;
  margin: 0;
  position: relative;
  border-top: none;
  min-height: 2rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .is-divider-vertical::before, .library_tile_view .flex-container .flex-item .card .card-body .is-divider-vertical::before {
  border-left: 3px solid #dbdbdb;
  bottom: 1rem;
  content: "";
  display: block;
  position: absolute;
  top: 1rem;
  transform: translateX(-50%);
}
.library_tile_view .flex-container .flex-item .card .card-content .embQuestStyle, .library_tile_view .flex-container .flex-item .card .card-body .embQuestStyle {
  text-align: left;
  font-size: 16px;
}
.library_tile_view .flex-container .flex-item .card .card-content .responsiveRadioBtn, .library_tile_view .flex-container .flex-item .card .card-body .responsiveRadioBtn {
  margin: 10px 0px;
}
.library_tile_view .flex-container .flex-item .card .card-content section.section, .library_tile_view .flex-container .flex-item .card .card-body section.section {
  padding: 1rem 2rem 0rem 0rem;
}
.library_tile_view .flex-container .flex-item .card .card-content section.section .removeAssQuestion, .library_tile_view .flex-container .flex-item .card .card-body section.section .removeAssQuestion {
  float: right;
  top: -32px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: relative;
  right: -29px;
}
.library_tile_view .flex-container .flex-item .card .card-content section.section .removeAssQuestion:hover, .library_tile_view .flex-container .flex-item .card .card-body section.section .removeAssQuestion:hover {
  color: #d62e2e !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .title, .library_tile_view .flex-container .flex-item .card .card-body .title {
  font-size: 14px !important;
  margin-bottom: 4px;
  white-space: nowrap;
  width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.library_tile_view .flex-container .flex-item .card .card-content .description, .library_tile_view .flex-container .flex-item .card .card-body .description {
  font-size: 12px !important;
  color: #000 !important;
  margin-bottom: 4px;
  white-space: nowrap;
  width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.library_tile_view .flex-container .flex-item .card .card-content .shareBtnOptions, .library_tile_view .flex-container .flex-item .card .card-body .shareBtnOptions {
  position: relative;
  top: -15px;
  line-height: 1;
  z-index: 10;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions {
  position: relative;
  top: -25px;
  right: -15px;
  line-height: 1;
  z-index: 10;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown {
  position: relative;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-menu, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-menu {
  min-width: 6rem;
  z-index: 20;
  position: absolute;
  right: 0;
  top: 100%;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-menu .dropdown-item .fa, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-menu .dropdown-item .fa {
  font-size: 12px !important;
  margin-right: 5px;
  margin-top: 5px;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-menu hr, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-menu hr {
  margin: 0px;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .dropdown .dropdown-trigger, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .dropdown .dropdown-trigger {
  position: relative;
  top: 8px;
  right: 5px;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .hiddenDownloadLink, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .hiddenDownloadLink {
  display: none;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions a, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions a {
  color: #000;
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions a:hover, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions a:hover {
  color: var(--primaryColor);
}
.library_tile_view .flex-container .flex-item .card .card-content .fileBtnOptions .hiddenDownloadLink, .library_tile_view .flex-container .flex-item .card .card-body .fileBtnOptions .hiddenDownloadLink {
  pointer-events: none;
}
.library_tile_view .flex-container .flex-item .card .card-content .shared, .library_tile_view .flex-container .flex-item .card .card-body .shared {
  margin-bottom: 2px;
  font-size: 13px;
  color: #ccc;
  text-transform: capitalize;
}
.library_tile_view .flex-container .flex-item .card .card-content .subtitle, .library_tile_view .flex-container .flex-item .card .card-body .subtitle {
  margin-bottom: 2px;
  font-size: 13px;
  color: #ccc;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP, .library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP {
  align-items: center;
  color: #3c3b37;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .price-text--price-part--Tu6MH, .library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .price-text--price-part--Tu6MH {
  line-height: 1;
  padding: 0.4rem 0;
  margin-right: 0.8rem;
  white-space: nowrap;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .price-text--price-part--Tu6MH:last-child, .library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .price-text--price-part--Tu6MH:last-child {
  margin-right: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .price-text--original-price--2e-F5, .library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .price-text--original-price--2e-F5 {
  color: #73726c;
}
.library_tile_view .flex-container .flex-item .card .card-content .price-text--container--Ws-fP .udlite-sr-only, .library_tile_view .flex-container .flex-item .card .card-body .price-text--container--Ws-fP .udlite-sr-only {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.library_tile_view .flex-container .flex-item .card .card-content .btn_buylesson, .library_tile_view .flex-container .flex-item .card .card-body .btn_buylesson {
  float: right;
  position: absolute;
  right: 10px;
  line-height: 2.2;
  bottom: 20px;
}
.library_tile_view .flex-container .flex-item .card .card-content .btn_buylesson .button, .library_tile_view .flex-container .flex-item .card .card-body .btn_buylesson .button {
  margin-left: 10px;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox], .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] .is-rtl + label, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] .is-rtl + label {
  padding-left: 0;
  padding-right: 3.5rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] + label, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 3.5rem;
  padding-top: 0.2rem;
  cursor: pointer;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox]:checked + label::before, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked + label::before {
  background: #00d1b2;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie {
  margin-bottom: 20px;
  padding: 1rem 1.5rem !important;
  border: 1px solid #d4d4d4;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .questionariesTabul, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .questionariesTabul {
  font-size: 15px;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-choice, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-choice {
  padding: 0rem 0rem 1rem 0rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .questionOption, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .questionOption {
  padding: 0rem 0rem !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .radio-group, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .radio-group {
  width: 0px !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control {
  margin-bottom: 10px;
  width: 90%;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control ul .editQuizContent, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control ul .editQuizContent {
  margin-left: 0em !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .removeOptions, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .removeOptions {
  float: right;
  top: 5px;
  width: 30px;
  height: 30px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: absolute;
  right: -69px;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .removeOptions:hover, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .removeOptions:hover {
  color: #d62e2e !important;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox], .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio] + label:first-of-type,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox] + label:first-of-type, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio] + label:first-of-type,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox] + label:first-of-type {
  float: right;
  position: absolute;
  margin-left: 10px;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:before,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:before, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:before,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:before {
  animation-name: none;
  border: 0.1rem solid #dbdbdb;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:after,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:after, .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:after,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:after {
  display: inline-block;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .survey_question .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-content .questionnarie .survey_question .is-checkradio[type=checkbox], .library_tile_view .flex-container .flex-item .card .card-body .questionnarie .survey_question .is-checkradio[type=radio],
.library_tile_view .flex-container .flex-item .card .card-body .questionnarie .survey_question .is-checkradio[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .questionnarieAns, .library_tile_view .flex-container .flex-item .card .card-body .questionnarieAns {
  padding: 2rem 0rem;
  margin-top: -7%;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox], .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-small + label, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-small + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: normal;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success:checked + label:before, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label:before {
  background: var(--primaryColor);
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-sucess + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success + label:before, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-sucess + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:before {
  left: auto;
  right: -0.375rem;
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] + label::before,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox] + label:before, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label::before,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label:before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: 0.25rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox].is-success + label:after, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox]:checked.is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-content .switch[type=checkbox]:checked.is-success + label:after, .library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label::after,
.library_tile_view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label:after {
  left: auto;
  right: 0;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish {
  width: 100% !important;
  margin-left: 26px;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .responsiveRadioBtn {
  margin: 20px 0;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: bold;
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label::before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: -0.375rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library_tile_view .flex-container .flex-item .card .card-footer .lessonSubmitBtn {
  position: absolute;
  top: 5px;
  right: 0px;
}
.library_tile_view .flex-container .flex-item .card .card-footer .actBtnMobileView {
  display: none;
}
.library_tile_view .flex-container .flex-item .card .card-header .card-header-title {
  font-size: 19px !important;
}
.library_tile_view .flex-container .flex-item .card .buylesson {
  position: absolute;
  top: 0px;
  z-index: 9;
  height: 50px;
  display: none;
  font-size: 15px;
  bottom: 0px;
}
.library_tile_view .editedFileUpload .card .card-content {
  overflow-y: auto;
  max-height: calc(100vh - 253px);
}
.library_tile_view .editedFileUpload .card .card-body {
  padding: 1rem !important;
}

.modal-card {
  width: calc(100% - 20px);
}

.modal-card-title {
  font-size: 1.2rem;
}

.modal-content-body {
  position: relative;
  margin: 0 auto;
  max-height: calc(100vh - 40px);
  width: calc(100% - 100px);
}
.modal-content-body .modal-card-body {
  max-height: calc(100vh - 200px);
  overflow: auto;
  min-height: 50vh;
  background: hsl(0, 0%, 98%);
}

.modal-card-head {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  background: var(--popupwindowheadbg);
}
.modal-card-head p {
  color: #fff;
}

.modal-card-foot {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  justify-content: end;
  min-height: 50px;
}
.modal-card-foot .button.is-link {
  background: var(--popupwindowheadbg) !important;
}

.policy-upload #questiontopic::placeholder {
  color: rgb(182, 182, 182) !important;
  text-transform: capitalize;
  font-size: 1rem !important;
}
.policy-upload .tabs {
  padding: 0rem 0rem;
}
.policy-upload .tabs .tab {
  pointer-events: none;
  opacity: 0.5;
}
.policy-upload .tabs .tab.is-active {
  opacity: 1;
  pointer-events: none;
}
.policy-upload .profile-img {
  width: 100% !important;
  height: 100px !important;
}
.policy-upload .profile-img img {
  width: 60px !important;
  border-radius: 0px !important;
  box-shadow: none !important;
  min-width: 50px !important;
}
.policy-upload .profile-img .file-cta {
  width: 150px;
  height: 100px;
  display: flex;
  justify-content: center;
  background-color: transparent !important;
  color: transparent !important;
  border-color: transparent !important;
}
.policy-upload .profile-img .file-cta .file-icon {
  justify-content: center;
}
.policy-upload .profile-img .file-cta .file-icon .fa-solid {
  font-size: 6rem !important;
  color: var(--primaryColor) !important;
}
.policy-upload .modal-dialog {
  max-width: calc(100vw - 50px) !important;
}
.policy-upload .modal-dialog .modal-content {
  width: 100% !important;
  overflow: hidden;
}
.policy-upload .modal-dialog .modal-body {
  padding: 0px !important;
}
.policy-upload .modal-dialog ::ng-deep .card {
  box-shadow: none !important;
}
.policy-upload .modal-dialog ::ng-deep .card .card-body {
  height: calc(100vh - 230px) !important;
  overflow: auto;
}
.policy-upload .modal-dialog .modal-footer {
  border-top: 1px solid #dbdbdb;
}

.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  scrollbar-width: none;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}
.modal-dialog .btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.modal-dialog .btn-cancel {
  background-color: #eee;
  color: #111;
}
.modal-dialog .btn {
  padding: 0.3rem 0.8rem !important;
}

.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}

.modal.show {
  display: block;
}

.modal-header {
  background: var(--primaryColor);
  color: #fff;
}

.summarization-popup .modal-content {
  overflow: hidden;
}
.summarization-popup .modal-body {
  overflow-y: auto;
}

::ng-deep .formatted-table {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}

::ng-deep .formatted-table th {
  background: linear-gradient(135deg, #34495e, #2c3e50);
  color: white;
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  border: none;
}

::ng-deep .formatted-table td {
  padding: 12px;
  border-bottom: 1px solid #ecf0f1;
  border-right: 1px solid #ecf0f1;
  vertical-align: top;
  transition: background-color 0.2s ease;
}

::ng-deep .formatted-table tr:hover td {
  background-color: #f8f9fa;
}

::ng-deep .formatted-table tr:nth-child(even) td {
  background-color: #fdfdfd;
}

::ng-deep .formatted-table tr:last-child td {
  border-bottom: none;
}

::ng-deep .formatted-table td:last-child {
  border-right: none;
}

/* Heading Styles */
::ng-deep .formatted-heading {
  color: #2c3e50;
  margin: 25px 0 15px 0;
  font-weight: 600;
  position: relative;
}

::ng-deep .formatted-heading.h1 {
  font-size: 1.5em;
  border-bottom: 3px solid #3498db;
  padding-bottom: 10px;
}

::ng-deep .formatted-heading.h2 {
  font-size: 1.2em;
  border-bottom: 2px solid #3498db;
  padding-bottom: 8px;
}

::ng-deep .formatted-heading.h3 {
  font-size: 1.3em;
  color: #34495e;
}

::ng-deep .formatted-heading.h4 {
  font-size: 1.2em;
  color: #34495e;
}

::ng-deep .formatted-heading.h5 {
  font-size: 1.1em;
  color: #34495e;
}

::ng-deep .formatted-heading.h6 {
  font-size: 1em;
  color: #34495e;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.survey-modal .card-content, .poll-modal .card-content {
  padding: 1rem 1.5rem !important;
}
.survey-modal .survey-question:first-child h3, .survey-modal .poll-question:first-child h3, .poll-modal .survey-question:first-child h3, .poll-modal .poll-question:first-child h3 {
  margin-top: 0px !important;
}

/**************radio button***************/
.radio-group {
  width: 250px !important;
}

.radio {
  margin: 0.5rem;
}
.radio input[type=radio] {
  position: absolute;
  opacity: 0;
}
.radio input[type=radio] + .radio-label a {
  font-weight: bold;
}
.radio input[type=radio] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.1em;
  margin-right: 0.5em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type=radio]:checked + .radio-label:before {
  background-color: #3197EE;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type=radio]:focus + .radio-label:before {
  outline: none;
  border-color: #3197EE;
}
.radio input[type=radio]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type=radio] + .radio-label:empty:before {
  margin-right: 0;
}

@media screen and (max-width: 320px) and (max-width: 767px) {
  .library_tile_view .flex-container .flex-item .card .card-footer .actBtnDeskView {
    display: none;
  }
  .library_tile_view .flex-container .flex-item .card .card-footer .actBtnMobileView {
    display: block;
    float: right;
  }
  .library_tile_view .flex-item {
    width: 319px;
  }
  .library_tile_view .flex-item .responsiveRadioBtn {
    margin: 20px 0;
  }
  .library_tile_view .flex-item .questionnarieMobile {
    margin-top: 10px;
  }
  .library_tile_view .flex-item .card .card-content .questionnarie .question-option .control, .library_tile_view .flex-item .card .card-body .questionnarie .question-option .control {
    width: 176px;
  }
  .library_tile_view .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label::before,
  .library_tile_view .flex-item .card .card-content .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label:before, .library_tile_view .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label::before,
  .library_tile_view .flex-item .card .card-body .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label:before {
    border: 3px solid #f14668;
  }
  .library_tile_view .flex-item .card .card-content .interactiveScroll .is-divider-vertical, .library_tile_view .flex-item .card .card-body .interactiveScroll .is-divider-vertical {
    display: block;
    flex: none;
    width: auto;
    height: auto;
    padding: 2rem;
    margin: 0;
    position: relative;
    border-top: none;
    min-height: 2rem;
  }
  .library_tile_view .flex-item .card .card-content .interactiveScroll .is-divider-vertical::before, .library_tile_view .flex-item .card .card-body .interactiveScroll .is-divider-vertical::before {
    border-left: 0.1rem solid #dbdbdb;
    bottom: 1rem;
    content: "";
    display: block;
    left: 50%;
    position: absolute;
    top: 1rem;
    transform: translateX(-50%);
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish {
    width: 100% !important;
    margin-left: 26px;
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .responsiveRadioBtn {
    margin: 20px 0;
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label {
    position: relative;
    display: initial;
    font-size: 1rem;
    line-height: initial;
    padding-left: 0;
    padding-right: 3.5rem;
    cursor: pointer;
    font-weight: bold;
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label::before {
    position: absolute;
    display: block;
    top: 0;
    left: auto;
    right: -0.375rem;
    width: 3rem;
    height: 1.5rem;
    border: 0.1rem solid transparent;
    border-radius: 4px;
    background: #b5b5b5;
    content: "";
  }
  .library_tile_view .flex-item .card .card-footer .lessonPublish .switch[type=checkbox].is-success + label:after {
    display: block;
    position: absolute;
    top: 0.25rem;
    left: auto;
    right: 1.425rem;
    width: 1rem;
    height: 1rem;
    transform: translate3d(0, 0, 0);
    border-radius: 4px;
    background: var(--whiteColor);
    transition: all 0.25s ease-out;
    content: "";
  }
  .library_tile_view .flex-item .card .card-footer .lessonSubmitBtn {
    position: absolute;
    top: 5px;
    right: 0px;
  }
}
.elibPlaying-Media .columns .column .card .card-table .content .list-wrapper ul .selectedActive {
  background: var(--listbackgoundhover) !important;
  border-bottom: 1px solid var(--listcolor) !important;
  border-top: 1px solid var(--listcolor) !important;
}
.elibPlaying-Media .columns .column .card .card-table .content .list-wrapper ul .selectedActive .title, .elibPlaying-Media .columns .column .card .card-table .content .list-wrapper ul .selectedActive .shared {
  color: var(--listcolor) !important;
}

.content .list-wrapper ul li {
  margin-top: 0px !important;
  border-bottom: 1px solid #f1f2f5 !important;
}
.content .list-wrapper ul li .title {
  color: var(--textsecondarycolor) !important;
}
.content .list-wrapper ul li .shared {
  color: #999 !important;
}
.content .list-wrapper ul li .is-checkradio[type=checkbox]:checked + label:before {
  border: 0.1rem solid #0eab72 !important;
}
.content .list-wrapper ul li .is-checkradio[type=checkbox]:checked + label:after {
  border-color: #0eab72 !important;
}

.list-wrapper li:hover {
  background: var(--listbackgoundhover) !important;
}
.list-wrapper li:hover .title, .list-wrapper li:hover .shared {
  color: var(--listcolor) !important;
}

.lessonSubmitBtn.disabled {
  pointer-events: none !important;
}

.assQuestTest .label {
  color: #353535 !important;
}

/***********card check box********/
.checkbox-wrapper {
  box-sizing: border-box;
  --background-color: #fff;
  --checkbox-height:20px;
}
@keyframes dothabottomcheck-19 {
  0% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) / 2);
  }
}
@keyframes dothatopcheck-19 {
  0% {
    height: 0;
  }
  50% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) * 1.2);
  }
}
.card-image .checkbox-wrapper {
  position: absolute;
  z-index: 1;
  top: 2px;
  right: 2px;
}

.checkbox-wrapper input[type=checkbox] {
  display: none;
}

.checkbox-wrapper .check-box {
  height: var(--checkbox-height);
  width: var(--checkbox-height);
  background-color: transparent;
  border: calc(var(--checkbox-height) * 0.1) solid #858585;
  border-radius: 5px;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  transition: border-color ease 0.2s;
  cursor: pointer;
}

.checkbox-wrapper .check-box::before,
.checkbox-wrapper .check-box::after {
  box-sizing: border-box;
  position: absolute;
  height: 0;
  width: calc(var(--checkbox-height) * 0.2);
  background-color: #34b93d;
  display: inline-block;
  transform-origin: left top;
  border-radius: 5px;
  content: " ";
  transition: opacity ease 0.5;
}

.checkbox-wrapper .check-box::before {
  top: calc(var(--checkbox-height) * 0.72);
  left: calc(var(--checkbox-height) * 0.41);
  box-shadow: 0 0 0 calc(var(--checkbox-height) * 0.05) var(--background-color);
  transform: rotate(-135deg);
}

.checkbox-wrapper .check-box::after {
  top: calc(var(--checkbox-height) * 0.37);
  left: calc(var(--checkbox-height) * 0.05);
  transform: rotate(-45deg);
}

.checkbox-wrapper input[type=checkbox]:checked + .check-box,
.checkbox-wrapper .check-box.checked {
  border-color: #34b93d;
}

.checkbox-wrapper input[type=checkbox]:checked + .check-box::after,
.checkbox-wrapper .check-box.checked::after {
  height: calc(var(--checkbox-height) / 2);
  animation: dothabottomcheck-19 0.2s ease 0s forwards;
}

.checkbox-wrapper input[type=checkbox]:checked + .check-box::before,
.checkbox-wrapper .check-box.checked::before {
  height: calc(var(--checkbox-height) * 1.2);
  animation: dothatopcheck-19 0.4s ease 0s forwards;
}

.close-player-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}

.publish-user-modal .modern-modal {
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  max-width: 420px;
  width: 95%;
  margin: auto;
  transition: all 0.3s ease;
  z-index: 9999;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
@media (min-width: 767px) and (max-width: 956px) {
  .publish-user-modal .modern-modal {
    max-width: 500px !important;
    width: 90% !important;
    max-height: 92vh !important;
  }
}
@media (max-width: 766px) {
  .publish-user-modal .modern-modal {
    max-width: 95%;
    width: 95%;
    max-height: 95vh;
  }
}
@media (max-width: 480px) {
  .publish-user-modal .modern-modal {
    width: 100%;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    max-height: 100vh;
  }
}
.publish-user-modal .modern-modal-head {
  background: linear-gradient(135deg, #1571b9, #4c8dff);
  color: #fff;
  padding: 1rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  order: 0;
}
.publish-user-modal .modern-modal-head .modal-title {
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}
.publish-user-modal .modern-modal-head .delete {
  background: transparent;
  color: #fff;
  opacity: 0.8;
  transition: 0.2s;
}
.publish-user-modal .modern-modal-head .delete:hover {
  opacity: 1;
}
.publish-user-modal .modern-modal-body {
  padding: 1rem 1.2rem;
  background: #f9fafc;
  max-height: 60vh;
  overflow-y: auto;
  flex: 1;
}
@media (min-width: 767px) and (max-width: 956px) {
  .publish-user-modal .modern-modal-body {
    padding: 0.9rem 1.1rem !important;
    max-height: 62vh !important;
  }
}
@media (max-width: 766px) {
  .publish-user-modal .modern-modal-body {
    padding: 0.75rem 1rem;
    max-height: 65vh;
  }
}
@media (max-width: 480px) {
  .publish-user-modal .modern-modal-body {
    padding: 0.75rem;
    max-height: calc(100vh - 200px);
  }
}
.publish-user-modal .modern-modal-body .search-container {
  margin-bottom: 1rem;
}
.publish-user-modal .modern-modal-body .search-container .search-input {
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  transition: 0.2s;
}
.publish-user-modal .modern-modal-body .search-container .search-input:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
}
.publish-user-modal .modern-modal-body .search-container .clear-icon {
  cursor: pointer;
  color: #999;
}
.publish-user-modal .modern-modal-body .search-container .clear-icon:hover {
  color: #333;
}
.publish-user-modal .modern-modal-body .select-all-container {
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e0e0e0;
}
.publish-user-modal .modern-modal-body .select-all-container .select-all-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  padding: 0.75rem;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
  background: #f5f7fa;
}
.publish-user-modal .modern-modal-body .select-all-container .select-all-item:hover {
  background: #eef5ff;
}
.publish-user-modal .modern-modal-body .select-all-container .select-all-item.active {
  background: #dceeff;
  border-left: 3px solid #1571b9;
}
.publish-user-modal .modern-modal-body .select-all-container .select-all-item .user-avatar {
  background: #e8f0fe;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.publish-user-modal .modern-modal-body .select-all-container .select-all-item .user-name {
  flex: 1;
  font-weight: 600;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.publish-user-modal .modern-modal-body .select-all-container .select-all-item .check-icon {
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.publish-user-modal .modern-modal-body .user-list .user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
}
.publish-user-modal .modern-modal-body .user-list .user-item:hover {
  background: #eef5ff;
}
.publish-user-modal .modern-modal-body .user-list .user-item.active {
  background: #dceeff;
  border-left: 3px solid #1571b9;
}
.publish-user-modal .modern-modal-body .user-list .user-item .user-avatar {
  background: #e8f0fe;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.publish-user-modal .modern-modal-body .user-list .user-item .user-name {
  flex: 1;
  color: #333;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.publish-user-modal .modern-modal-body .user-list .user-item .check-icon {
  color: #1571b9;
  font-size: 1.2rem;
  flex-shrink: 0;
}
.publish-user-modal .modern-modal-foot {
  padding: 1rem 1.2rem;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  order: 2;
}
.publish-user-modal .modern-modal-foot .clear-btn {
  background: #f5f7fa;
  color: #666;
  border: 1px solid #ddd;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}
.publish-user-modal .modern-modal-foot .clear-btn:hover {
  background: #eef5ff;
  border-color: #1571b9;
  color: #1571b9;
}
.publish-user-modal .modern-modal-foot .button-group {
  display: flex;
  gap: 0.75rem;
}
.publish-user-modal .modern-modal-foot .button-group .cancel-btn {
  background: #fff;
  color: #666;
  border: 1px solid #ddd;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s;
}
.publish-user-modal .modern-modal-foot .button-group .cancel-btn:hover {
  background: #f5f7fa;
  border-color: #999;
}
.publish-user-modal .modern-modal-foot .button-group .publish-btn {
  background: linear-gradient(135deg, #1571b9, #4c8dff);
  color: #fff;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}
.publish-user-modal .modern-modal-foot .button-group .publish-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #0f5a9a, #3a7ae8);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(21, 113, 185, 0.3);
}
.publish-user-modal .modern-modal-foot .button-group .publish-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/components/elibraryandcourse/e-library/e-library-details/e-library-tile/e-library-tile.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,oBAAA;EACA,8BAAA;AAEJ;AADI;EACI,mCAAA;AAGR;AAAO;EACC,uDAAA;AAER;AACI;EACI,+BAAA;AACR;;AAEA;EACG,uBAAA;AACH;;AACA;EACE,2BAAA;AAEF;;AACA;EACI,mCAAA;AAEJ;AACI;;;;EAIE,kBAAA;AACN;AAAM;;;;;;;EAEE,sBAAA;AAOR;AAFG;EACG,kBAAA;EACA,iBAAA;AAIN;AAFM;EAEE,kBAAA;EACA,iBAAA;AAGR;AADQ;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;AAGV;AAFU;EACE,oCAAA;AAIZ;AAFU;EACE,sBAAA;AAIZ;AADQ;EACE,0BAAA;AAGV;AAGI;EACG,uBAAA;AADP;AAIM;EACE,aAAA;AAFR;AAKE;EACE,+BAAA;EACA,4DAAA;AAHJ;AAIM;EACF,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAFJ;AAGI;EACE,wBAAA;AADN;AAGI;EACE,aAAA;AADN;AAGI;EACE,UAAA;AADN;AAEM;EACG,0CAAA;AAAT;AAEM;EACE,qCAAA;AAAR;AAEO;EACC,aAAA;AAAR;AAEM;EACG,qBAAA;AAAT;AAEO;EACC,qBAAA;AAAR;AAGM;EACA,UAAA;AADN;AAEM;EACG,8BAAA;AAAT;AAEM;EACE,aAAA;AAAR;AAEM;EACG,qBAAA;AAAT;AAEM;EACE,qBAAA;EACC,8BAAA;EACA,sBAAA;AAAT;AAGM;EACA,oCAAA;AADN;AAGM;EACE,yBAAA;AADR;AAQI;EACE,mBAAA;EACD,kBAAA;EACD,iBAAA;EACA,cAAA;EACA,mBAAA;AANJ;AAQI;EACE,gDAAA;EACA,WAAA;EACA,eAAA;AANN;AAYI;EACI,uBAAA;EACA,4BAAA;AAVR;AAaM;EAEE,UAAA;EACA,eAAA;EACA,8BAAA;AAZR;AAaS;EACC,4BAAA;AAXV;AAaQ;EACI,sBAAA;AAXZ;AAcQ;EACE,yBAAA;AAZV;AAcQ;EACE,iBAAA;AAZV;AAiBQ;EACE,4BAAA;AAfV;AAiBU;EACC,qBAAA;AAfX;AAiBQ;EACI,sBAAA;AAfZ;AAiBQ;EACE,iBAAA;AAfV;AAkBU;EACA,yBAAA;AAhBV;AAkBS;EACC,iCAAA;AAhBV;AAsBQ;EACE,6EAAA;EACA,kBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;AApBV;AAqBU;EACE,qBAAA;EACA,WAAA;AAnBZ;AAqBW;EACA,eAAA;AAnBX;AAqBU;EACE,iBAAA;AAnBZ;AAqBU;EACE,cAAA;AAnBZ;AAsBU;EACE,eAAA;EACA,2BAAA;EACA,8CAAA;EACA,iCAAA;EACA,UAAA;AApBZ;AAkCY;EAIE,gBAAA;AAnCd;AAsCY;EACE,yBAAA;AApCd;AAuCY;EACE,yBAAA;AArCd;AAwCY;EACE,yBAAA;AAtCd;AA0CU;EACE,eAAA;EAEA,mBAAA;AAzCZ;AA0CY;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAxCd;AA0Cc;EACE,cAAA;EACA,0BAAA;AAxChB;AA2CU;EACE,YAAA;AAzCZ;AA2CY;EACE,YAAA;EACA,cAAA;EAGA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AA3Cd;AA8CY;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AA5Cd;AAgDU;EACE,0BAAA;EACA,gBAAA;AA9CZ;AA+CU;EACE,8BAAA;AA7CZ;AA+CY;EACE,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA7Cd;AA+Cc;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EAEA,kBAAA;EACA,SAAA;EAGA,2BAAA;AA9ChB;AAkDY;EACE,gBAAA;EACA,eAAA;AAhDd;AAgEY;EACE,gBAAA;AA9Dd;AAwFY;EACE,4BAAA;AAtFd;AAwFc;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAtFhB;AAwFgB;EACE,yBAAA;AAtFlB;AA2FY;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAzFd;AA4FY;EACE,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AA1Fd;AA6FY;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AA3Fd;AA8FY;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;AA5Fd;AA+Fc;EACE,kBAAA;AA7FhB;AA8FgB;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AA5FlB;AA+FoB;EACE,0BAAA;EACA,iBAAA;EACA,eAAA;AA7FtB;AAiGkB;EACE,WAAA;AA/FpB;AAmGgB;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAjGlB;AAqGc;EACE,aAAA;AAnGhB;AAsGc;EACE,WAAA;AApGhB;AAsGgB;EACE,0BAAA;AApGlB;AAwGc;EACE,oBAAA;AAtGhB;AA0GY;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;AAxGd;AA2GY;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AAzGd;AA4GY;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA1Gd;AA4Gc;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AA1GhB;AA4GgB;EACE,eAAA;AA1GlB;AA8Gc;EACE,cAAA;AA5GhB;AA+Gc;EACE,6BAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,8BAAA;AA7GhB;AAiHY;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AA/Gd;AAiHc;EACE,iBAAA;AA/GhB;AAmHY;EACE,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AAjHd;AAoHgB;EACE,eAAA;EACA,qBAAA;AAlHlB;AAsHc;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AApHhB;AAyHkB;EACE,mBAAA;AAvHpB;AA6HY;EAEE,mBAAA;EACA,+BAAA;EACA,yBAAA;AA5Hd;AA+HgB;EACE,eAAA;AA7HlB;AAiIc;EACE,4BAAA;AA/HhB;AAkIc;EACE,6BAAA;AAhIhB;AAqIkB;EACE,qBAAA;AAnIpB;AAqIgB;EACE,mBAAA;EACA,UAAA;AAnIlB;AAsIoB;EACE,2BAAA;AApItB;AAwIkB;EACE,YAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAtIpB;AAwIoB;EACE,yBAAA;AAtItB;AA0IkB;;;EAEE,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AAvIpB;AA0IkB;;;EAEE,YAAA;EACA,kBAAA;EACA,iBAAA;AAvIpB;AA0IkB;;;;;;;EAIE,oBAAA;EACA,4BAAA;AArIpB;AAwIkB;;;;;;;EAIE,qBAAA;AAnIpB;AA0IgB;;;EAEE,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AAvIlB;AA4IY;EACE,kBAAA;EACA,eAAA;AA1Id;AA6IY;EACE,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AA3Id;AA8IY;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AA5Id;AA+IY;;;EAEE,+BAAA;AA5Id;AA+IY;;;EAEE,UAAA;EACA,gBAAA;AA5Id;AA+IY;;;EAEE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA5Id;AAoJY;;;EAEE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,WAAA;AAjJd;AAoJY;;;EAEE,UAAA;EACA,QAAA;AAjJd;AAsJY;EACE,sBAAA;EACA,iBAAA;AApJd;AAsJc;EACE,cAAA;AApJhB;AAuJc;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AArJhB;AAwJc;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAtJhB;AAyJc;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,WAAA;AAvJhB;AA2JY;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAzJd;AA4JY;EACE,aAAA;AA1Jd;AA+JY;EACE,0BAAA;AA7Jd;AAiKU;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AA/JZ;AAwKQ;EACE,gBAAA;EACA,+BAAA;AAtKV;AA0KQ;EACE,wBAAA;AAxKV;;AAiLE;EACE,wBAAA;AA9KJ;;AAiLE;EACE,iBAAA;AA9KJ;;AAgLE;EACE,kBAAA;EACA,cAAA;EACA,8BAAA;EAEA,yBAAA;AA9KJ;AA+KK;EACG,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;AA7KR;;AAkLE;EACE,2BAAA;EACA,4BAAA;EACA,oCAAA;AA/KJ;AAgLI;EACE,WAAA;AA9KN;;AAmLE;EACE,8BAAA;EACA,+BAAA;EACA,oBAAA;EACA,gBAAA;AAhLJ;AAiLI;EACE,+CAAA;AA/KN;;AAsLK;EACC,oCAAA;EACA,0BAAA;EACA,0BAAA;AAnLN;AAqLI;EACC,kBAAA;AAnLL;AAsLQ;EACE,oBAAA;EACA,YAAA;AApLV;AAwLQ;EACE,UAAA;EACA,oBAAA;AAtLV;AA2LI;EACU,sBAAA;EACA,wBAAA;AAzLd;AA0Lc;EACG,sBAAA;EACD,6BAAA;EACA,2BAAA;EACA,0BAAA;AAxLhB;AA0Lc;EACM,YAAA;EACD,aAAA;EACD,aAAA;EACA,uBAAA;EACC,wCAAA;EACA,6BAAA;EACA,oCAAA;AAxLnB;AAyLkB;EACG,uBAAA;AAvLrB;AAwLqB;EACC,0BAAA;EACA,qCAAA;AAtLtB;AA2LI;EACI,wCAAA;AAzLR;AA0LQ;EACI,sBAAA;EACA,gBAAA;AAxLZ;AA0LQ;EACI,uBAAA;AAxLZ;AA4LS;EACG,2BAAA;AA1LZ;AA2LY;EACI,sCAAA;EACD,cAAA;AAzLf;AA4LQ;EACE,6BAAA;AA1LV;;AA+LI;EACI,6BAAA;AA5LR;AA8LI;EACI,8BAAA;AA5LR;AA8LI;EAGE,qBAAA;AA9LN;AAgMI;EACI,4BAAA;EACA,sBAAA;AA9LR;AAgMI;EACI,0CAAA;EACA,sBAAA;AA9LR;AAgMI;EACI,sBAAA;EACA,WAAA;AA9LR;AAgMI;EACI,iCAAA;AA9LR;;AAiMA;EACI,8BAAA;AA9LJ;;AAgMA;EACI,cAAA;AA7LJ;;AA+LA;EACI,+BAAA;EACA,WAAA;AA5LJ;;AA+LE;EACE,gBAAA;AA5LJ;AA8LE;EACE,gBAAA;AA5LJ;;AAmMA;EACgB,yBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;AAhMhB;;AAmMC;EACe,qDAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AAhMhB;;AAmMA;EACgB,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,mBAAA;EACA,sCAAA;AAhMhB;;AAmMA;EACgB,yBAAA;AAhMhB;;AAmMA;EACgB,yBAAA;AAhMhB;;AAmMA;EACgB,mBAAA;AAhMhB;;AAmMA;EACgB,kBAAA;AAhMhB;;AAmMY,mBAAA;AACZ;EACgB,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAhMhB;;AAmMA;EACgB,gBAAA;EACA,gCAAA;EACA,oBAAA;AAhMhB;;AAmMA;EACgB,gBAAA;EACA,gCAAA;EACA,mBAAA;AAhMhB;;AAmMA;EACgB,gBAAA;EACA,cAAA;AAhMhB;;AAmMA;EACgB,gBAAA;EACA,cAAA;AAhMhB;;AAmMA;EACgB,gBAAA;EACA,cAAA;AAhMhB;;AAmMA;EACgB,cAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AAhMhB;;AAqMI;EACE,+BAAA;AAlMN;AAqMM;EACE,0BAAA;AAnMR;;AAyMG,0CAAA;AAGH;EACE,uBAAA;AAxMF;;AA0MA;EACE,cAAA;AAvMF;AAwME;EACE,kBAAA;EACA,UAAA;AAtMJ;AAwMM;EACE,iBAAA;AAtMR;AAwMM;EACE,WAAA;EACA,mBAhBG;EAiBH,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAtMR;AA2MQ;EACE,yBAjCD;EAkCC,mCAAA;AAzMV;AA+MQ;EACE,aAAA;EACA,qBA1CD;AAnKT;AAmNQ;EACE,mCAAA;EACA,qBAAA;EACA,mBAAA;AAjNV;AAuNQ;EACE,eAAA;AArNV;;AA6NE;EAMc;IACE,aAAA;EA/NhB;EAkOc;IACE,cAAA;IACA,YAAA;EAhOhB;EA0OM;IACE,YAAA;EAxOR;EA0OQ;IACE,cAAA;EAxOV;EA2OQ;IACE,gBAAA;EAzOV;EAkPgB;IACE,YAAA;EAhPlB;EAkPkB;;;IAEE,yBAAA;EA/OpB;EAsPc;IACE,cAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,SAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;EApPhB;EAsPgB;IACE,iCAAA;IACA,YAAA;IACA,WAAA;IACA,cAAA;IACA,SAAA;IACA,kBAAA;IACA,SAAA;IAGA,2BAAA;EApPlB;EA2PY;IACE,sBAAA;IACA,iBAAA;EAzPd;EA2Pc;IACE,cAAA;EAzPhB;EA4Pc;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,oBAAA;IACA,eAAA;IACA,qBAAA;IACA,eAAA;IACA,iBAAA;EA1PhB;EA6Pc;IACE,kBAAA;IACA,cAAA;IACA,MAAA;IACA,UAAA;IACA,gBAAA;IACA,WAAA;IACA,cAAA;IACA,gCAAA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;EA3PhB;EA8Pc;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;IACA,+BAAA;IACA,kBAAA;IACA,6BAAA;IACA,8BAAA;IACA,WAAA;EA5PhB;EAgQY;IACE,kBAAA;IACA,QAAA;IACA,UAAA;EA9Pd;AACF;AAwQE;EAGE,gDAAA;EACA,oDAAA;EACA,iDAAA;AAxQJ;AAyQI;EACE,kCAAA;AAvQN;;AA2QE;EACC,0BAAA;EACA,2CAAA;AAxQH;AAyQI;EACE,2CAAA;AAvQN;AAyQI;EACE,sBAAA;AAvQN;AA0QE;EACA,uCAAA;AAxQF;AA0QE;EACE,gCAAA;AAxQJ;;AAgRA;EACE,gDAAA;AA7QF;AA8QG;EACG,kCAAA;AA5QN;;AAiRE;EACI,+BAAA;AA9QN;;AAiRI;EACE,yBAAA;AA9QN;;AAmRE,kCAAA;AACA;EACE,sBAAA;EACA,wBAAA;EACA,sBAAA;AAhRJ;AAwSE;EACE;IACE,SAAA;EArRJ;EAuRE;IACE,wCAAA;EArRJ;AACF;AAyRE;EACE;IACE,SAAA;EAvRJ;EAyRE;IACE,SAAA;EAvRJ;EAyRE;IACE,0CAAA;EAvRJ;AACF;AAsTI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AA9RN;;AAiSE;EACE,aAAA;AA9RJ;;AAkSE;EACE,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,wDAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EAGA,sBAAA;EAIA,kCAAA;EACA,eAAA;AA/RJ;;AAiSE;;EAIE,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,yCAAA;EACA,yBAAA;EACA,qBAAA;EAKA,0BAAA;EACA,kBAAA;EACA,YAAA;EAGA,4BAAA;AA9RJ;;AAgSE;EACE,wCAAA;EACA,yCAAA;EACA,6EAAA;EAKA,0BAAA;AA7RJ;;AA+RE;EACE,wCAAA;EACA,yCAAA;EAKA,yBAAA;AA5RJ;;AAgSE;;EAEE,qBAAA;AA7RJ;;AA+RE;;EAEE,wCAAA;EAIA,oDAAA;AA5RJ;;AA8RE;;EAEE,0CAAA;EAIA,iDAAA;AA3RJ;;AA6RE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA1RJ;;AA+RE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA5RJ;AA8RI;EAdF;IAeI,2BAAA;IACA,qBAAA;IACA,2BAAA;EA3RJ;AACF;AA6RI;EApBF;IAqBI,cAAA;IACA,UAAA;IACA,gBAAA;EA1RJ;AACF;AA4RI;EA1BF;IA2BI,WAAA;IACA,eAAA;IACA,SAAA;IACA,gBAAA;IACA,iBAAA;EAzRJ;AACF;AA4RE;EACE,qDAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AA1RJ;AA4RI;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA1RN;AA6RI;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA3RN;AA6RM;EACE,UAAA;AA3RR;AAgSE;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;AA9RJ;AAgSI;EAPF;IAQI,iCAAA;IACA,2BAAA;EA7RJ;AACF;AA+RI;EAZF;IAaI,qBAAA;IACA,gBAAA;EA5RJ;AACF;AA8RI;EAjBF;IAkBI,gBAAA;IACA,+BAAA;EA3RJ;AACF;AA6RI;EACE,mBAAA;AA3RN;AA6RM;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;AA3RR;AA6RQ;EACE,qBAAA;EACA,6CAAA;AA3RV;AA+RM;EACE,eAAA;EACA,WAAA;AA7RR;AA+RQ;EACE,WAAA;AA7RV;AAkSI;EACE,sBAAA;EACA,uBAAA;EACA,gCAAA;AAhSN;AAkSM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AAhSR;AAkSQ;EACE,mBAAA;AAhSV;AAmSQ;EACE,mBAAA;EACA,8BAAA;AAjSV;AAoSQ;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AAlSV;AAqSQ;EACE,OAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnSV;AAsSQ;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AApSV;AA0SM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;AAxSR;AA0SQ;EACE,mBAAA;AAxSV;AA2SQ;EACE,mBAAA;EACA,8BAAA;AAzSV;AA4SQ;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AA1SV;AA6SQ;EACE,OAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3SV;AA8SQ;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AA5SV;AAkTE;EACE,oBAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;AAhTJ;AAkTI;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhTN;AAkTM;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAhTR;AAoTI;EACE,aAAA;EACA,YAAA;AAlTN;AAoTM;EACE,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAlTR;AAoTQ;EACE,mBAAA;EACA,kBAAA;AAlTV;AAsTM;EACE,qDAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AApTR;AAsTQ;EACE,qDAAA;EACA,2BAAA;EACA,6CAAA;AApTV;AAuTQ;EACE,YAAA;EACA,mBAAA;AArTV","sourcesContent":[".card-body{\n    min-height:50vh;\n}\n.tabs{\n    padding:.5rem 0rem;\n    margin-bottom:0rem !important;\n    ul{\n        border-bottom-width:0px !important\n    }\n     .doc-views-tabs{\n       li.is-active {\n        border-bottom:1px solid var(--primaryColor) !important;\n      }\n    }\n    li.tab{\n        margin-bottom:.5em !important;\n    }\n}\n.tabs.is-boxed a{\n   border: none !important;\n}\n::ng-deep .angular-editor-textarea,::ng-deep .p-editor-container{\n  background: #fff !important;\n}\n \n.library_tile_view {\n    padding:0px 0px 7px 0px !important;\n\n    // Ensure Bulma tooltips show above cards and dropdowns\n    .has-tooltip-top,\n    .has-tooltip-right,\n    .has-tooltip-left,\n    .has-tooltip-bottom {\n      position: relative;\n      &::before,\n      &::after {\n        z-index: 50 !important;\n      }\n    }\n\n\n   .drag-drop-container {\n      position: relative;\n      overflow: visible;\n\n      .card{\n        // height:140px !important;\n        position: relative;\n        overflow: visible;\n\n        .dropdown-content{\n          padding:0px !important;\n          z-index: 999;\n          position: absolute;\n          .dropdown-item:hover{\n            background-color:#e7e7e7 !important;\n          }\n          .dropdown-divider{\n            margin:0px !important;\n          }\n        }\n        .tools{\n          margin-top:5px !important;\n        }\n      }\n   }\n\n\n    .tabs.stepper li a,.tabs.stepper li.is-active a{\n       border: none !important;\n    }  \n     .tabs:not(.stepper){\n      li span{\n        display: none;\n      }\n   }\n  .tabs.stepper{\n    padding:.3rem 5rem !important;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;\n      li{\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    margin-right:10px;\n    a{\n      padding:0px 5px 0px 5px;\n    }\n    span.check-mark,span.edit{\n      display: none;\n    }\n    &.is-active{\n      opacity: 1;\n      span:not(.line-horizontal){\n         background:var(--primaryColor) !important;\n      }\n      a{\n        color: var(--primaryColor) !important;\n      }\n       span{\n        display: none;\n      }\n      span.line-horizontal{\n         display:inline-block;\n      }\n       span.edit{\n        display: inline-block;\n      }\n     }\n      &.complete{\n      opacity: 1;\n      span{\n         background:#3BBFA1 !important;\n      }\n      span{\n        display: none;\n      }\n      span.line-horizontal{\n         display:inline-block;\n      }\n      span.check-mark{\n        display:inline-block;\n         background:#3BBFA1 !important;\n         color: #fff !important;\n      }\n     \n      span.line-horizontal{\n      border:1px solid #3BBFA1 !important;\n      }\n      a{\n        color: #3BBFA1 !important;\n      }\n   \n\n\n    }\n \n    span:not(.line-horizontal){\n      background: #626262;\n     text-align: center;\n    padding: 3px 10px;\n    color: #fffdfd;\n    border-radius: 100%;\n    }\n    span.line-horizontal{\n      border:1px solid var(--primaryColor) !important;\n      width:100%;\n      margin-top:5px;\n    }\n   }\n     \n  }\n   \n    .input{\n        height:2rem !important;\n        font-size:.9rem !important;\n      }\n \n      .questionnarie{\n   \n        width:97%;\n        margin:1% auto;\n        background:#fafafa !important;\n         .has-text-danger{\n          font-size:.9rem !important;\n        }\n        .input{\n            width:100% !important;\n        }\n       \n        .pi-trash,.pi-trash:hover{\n          color: #f14668 !important;\n        }\n        .icon{\n          margin-left:10px;\n        }\n      }  \n     \n      .question-option{\n        .has-text-danger{\n          font-size:.9rem !important;\n        }\n          .radio-group{\n           width:0px !important;\n         }\n        .input{\n            width:100% !important;\n        }\n        .icon{\n          margin-left:10px;\n        }\n         \n          .pi-trash,.pi-trash:hover{\n          color: #f14668 !important;\n        }\n         .is-checkradio[type=radio]  + label, .is-checkradio[type=checkbox]  + label{\n          padding:0.2rem 0.8rem !important;\n        }\n      }\n \n    .flex-container {\n      .flex-item {\n        .card {\n          transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n          border-radius: 6px;\n          border: 1px solid #e5e5e5;\n          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n          position: relative;\n          overflow: visible;\n          z-index: 1;\n          padding: 0.5rem;\n          .title{\n            margin-bottom:.2rem;\n            width:100%;\n           }\n           .title,.shared{\n           cursor: pointer;\n           }\n          .title,label{\n            font-size:.9rem;\n          }\n          .shared,.subtitle{\n            color: #a1a1a1;\n         \n          }\n          &:hover {\n            cursor: pointer;\n            transform: translateY(-3px);\n            box-shadow: 0 10px 25px rgba(15, 23, 42, 0.12);\n            border-color: var(--primaryColor);\n            z-index: 5;\n          //  .card-image {\n          //     background-color: #010101;\n          //     opacity: 0.7;\n \n          //     .thumb_play {\n          //       display: block;\n \n          //       .fa {\n          //         color: var(--whiteColor);\n          //       }\n          //     }\n          //   }\n \n            .button {\n              // background-color: #000;\n              // border-color: #000;\n              // color: #fff;\n              box-shadow: none;\n            }\n \n            .shareBtnOptions {\n              display: block !important;\n            }\n \n            .fileBtnOptions {\n              display: block !important;\n            }\n \n            .buylesson {\n              display: block !important;\n            }\n          }\n \n          .card-image {\n            cursor: pointer;\n            //  height:100px !important;\n            object-fit: contain;\n            .thumb_play {\n              position: absolute;\n              top: 48%;\n              left: 45%;\n              display: none;\n \n              .fa {\n                color: #dcdcdc;\n                font-size: 32px !important;\n              }\n            }\n          .lesson_image{\n            padding:5px;\n          }\n            .tile_imgcenter {\n              height:auto;\n              display: block;\n              // margin-left: auto;\n              // margin-right: auto;\n              width:100%;\n              padding: 10px;\n              object-fit: contain;\n              height: 146px;\n            }\n \n            .videoDuration {\n              font-size: 12px;\n              position: absolute;\n              right: 5px;\n              font-weight: 600;\n              background: #333;\n              color: var(--whiteColor);\n              bottom: 10px;\n              width: 59px;\n              text-align: center;\n            }\n          }\n \n          .card-content,.card-body {\n            cursor: default !important;\n            padding: 0.75rem;\n          .questionnaries{\n            border-left:1px solid #acacac;\n          }\n            .is-divider-vertical {\n              display: flex;\n              flex: none;\n              width: auto;\n              height: auto;\n              padding: 2rem;\n              margin: 0;\n              position: relative;\n              border-top: none;\n              min-height: 2rem;\n \n              &::before {\n                border-left: 3px solid #dbdbdb;\n                bottom: 1rem;\n                content: \"\";\n                display: block;\n                // left: 50%;\n                position: absolute;\n                top: 1rem;\n                -webkit-transform: translateX(-50%);\n                -ms-transform: translateX(-50%);\n                transform: translateX(-50%);\n              }\n            }\n \n            .embQuestStyle {\n              text-align: left;\n              font-size: 16px;\n            }\n \n            // .is-divider[data-content]::after,\n            // .is-divider-vertical[data-content]::after {\n            //   background: #fff;\n            //   color: #b5b5b5;\n            //   content: attr(data-content);\n            //   display: inline-block;\n            //   font-size: 0.75rem;\n            //   padding: 0.4rem 0.8rem;\n            //   -webkit-transform: translateY(-1.1rem);\n            //   -ms-transform: translateY(-1.1rem);\n            //   transform: translateY(-1.1rem);\n            //   text-align: center;\n            // }\n            .responsiveRadioBtn {\n              margin:10px 0px;\n            }\n \n            &:hover {\n              // .shareBtnOptions{\n              //   background-color: $secondary-color;\n              //   color:$complete-white-color;\n              //   width: 35px;\n              //   height: 35px;\n              //   border-radius: 27px;\n              //   // a{\n              //   //   color :#fff;\n              //   // }\n              // }\n              // .fileBtnOptions{\n              //   background-color: $secondary-color;\n              //   color:$complete-white-color;\n              //   width: 35px;\n              //   height: 35px;\n              //   border-radius: 27px;\n              //   // a{\n              //   //   color :#fff;\n              //   // }\n              // }\n            }\n \n            section.section {\n              padding: 1rem 2rem 0rem 0rem;\n \n              .removeAssQuestion {\n                float: right;\n                top: -32px;\n                text-align: center;\n                color: var(--whiteColor);\n                cursor: pointer;\n                position: relative;\n                right: -29px;\n \n                &:hover {\n                  color: #d62e2e !important;\n                }\n              }\n            }\n \n            .title {\n              font-size: 14px !important;\n              margin-bottom: 4px;\n              white-space: nowrap;\n              width: 121px;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n \n            .description {\n              font-size: 12px !important;\n              color: #000 !important;\n              margin-bottom: 4px;\n              white-space: nowrap;\n              width: 121px;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n \n            .shareBtnOptions {\n              position: relative;\n              top: -15px;\n              line-height: 1;\n              z-index: 10;\n            }\n \n            .fileBtnOptions {\n              position: relative;\n              top: -25px;\n              right: -15px;\n              line-height: 1;\n              z-index: 10;\n\n              // display: none;\n              .dropdown {\n                position: relative;\n                .dropdown-menu {\n                  min-width: 6rem;\n                  z-index: 20;\n                  position: absolute;\n                  right: 0;\n                  top: 100%;\n\n                  .dropdown-item {\n                    .fa {\n                      font-size: 12px !important;\n                      margin-right: 5px;\n                      margin-top: 5px;\n                    }\n                  }\n\n                  hr {\n                    margin: 0px;\n                  }\n                }\n\n                .dropdown-trigger {\n                  position: relative;\n                  top: 8px;\n                  right: 5px;\n                }\n              }\n \n              .hiddenDownloadLink {\n                display: none;\n              }\n \n              a {\n                color: #000;\n \n                &:hover {\n                  color: var(--primaryColor);\n                }\n              }\n \n              .hiddenDownloadLink {\n                pointer-events: none;\n              }\n            }\n \n            .shared {\n              margin-bottom: 2px;\n              font-size: 13px;\n              color: #ccc;\n              text-transform: capitalize;\n            }\n \n            .subtitle {\n              margin-bottom: 2px;\n              font-size: 13px;\n              color: #ccc;\n            }\n \n            .price-text--container--Ws-fP {\n              align-items: center;\n              color: #3c3b37;\n              display: flex;\n              flex-direction: row;\n              flex-wrap: wrap;\n \n              .price-text--price-part--Tu6MH {\n                line-height: 1;\n                padding: 0.4rem 0;\n                margin-right: 0.8rem;\n                white-space: nowrap;\n \n                &:last-child {\n                  margin-right: 0;\n                }\n              }\n \n              .price-text--original-price--2e-F5 {\n                color: #73726c;\n              }\n \n              .udlite-sr-only {\n                position: absolute !important;\n                height: 1px;\n                width: 1px;\n                overflow: hidden;\n                clip: rect(1px, 1px, 1px, 1px);\n              }\n            }\n \n            .btn_buylesson {\n              float: right;\n              position: absolute;\n              right: 10px;\n              line-height: 2.2;\n              bottom: 20px;\n \n              .button {\n                margin-left: 10px;\n              }\n            }\n \n            .switch[type=\"checkbox\"] {\n              outline: 0;\n              user-select: none;\n              display: inline-block;\n              position: absolute;\n              opacity: 0;\n \n              .is-rtl {\n                &+label {\n                  padding-left: 0;\n                  padding-right: 3.5rem;\n                }\n              }\n \n              &+label {\n                position: relative;\n                display: initial;\n                font-size: 1rem;\n                line-height: initial;\n                padding-left: 3.5rem;\n                padding-top: 0.2rem;\n                cursor: pointer;\n              }\n \n              &:checked {\n                &+label {\n                  &::before {\n                    background: #00d1b2;\n                  }\n                }\n              }\n            }\n \n            .questionnarie {\n           \n              margin-bottom: 20px;\n              padding:1rem 1.5rem !important;\n              border:1px solid #d4d4d4;\n             // box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n              .questionariesTab {\n                &ul {\n                  font-size: 15px;\n                }\n              }\n \n              .question-choice {\n                padding:0rem 0rem 1rem 0rem;\n              }\n \n              .questionOption {\n                padding: 0rem 0rem !important;\n              }\n \n              .question-option {\n               // padding: 1rem 9rem 3rem 2rem;\n                  .radio-group{\n                    width:0px !important;\n                  }\n                .control {\n                  margin-bottom: 10px;\n                  width:90%;\n \n                  ul {\n                    .editQuizContent {\n                      margin-left: 0em !important;\n                    }\n                  }\n \n                  .removeOptions {\n                    float: right;\n                    top: 5px;\n                    width: 30px;\n                    height: 30px;\n                    text-align: center;\n                    color: var(--whiteColor);\n                    cursor: pointer;\n                    position: absolute;\n                    right: -69px;\n \n                    &:hover {\n                      color: #d62e2e !important;\n                    }\n                  }\n \n                  .is-checkradio[type=\"radio\"],\n                  .is-checkradio[type=\"checkbox\"] {\n                    outline: 0;\n                    user-select: none;\n                    display: inline-block;\n                    position: absolute;\n                    opacity: 0;\n                  }\n \n                  .is-checkradio[type=\"radio\"]+label:first-of-type,\n                  .is-checkradio[type=\"checkbox\"]+label:first-of-type {\n                    float: right;\n                    position: absolute;\n                    margin-left: 10px;\n                  }\n \n                  .is-checkradio[type=\"radio\"]:checked+label::before,\n                  .is-checkradio[type=\"radio\"]:checked+label:before,\n                  .is-checkradio[type=\"checkbox\"]:checked+label::before,\n                  .is-checkradio[type=\"checkbox\"]:checked+label:before {\n                    animation-name: none;\n                    border: 0.1rem solid #dbdbdb;\n                  }\n \n                  .is-checkradio[type=\"radio\"]:checked+label::after,\n                  .is-checkradio[type=\"radio\"]:checked+label:after,\n                  .is-checkradio[type=\"checkbox\"]:checked+label::after,\n                  .is-checkradio[type=\"checkbox\"]:checked+label:after {\n                    display: inline-block;\n                  }\n                }\n              }\n \n              .survey_question {\n \n                .is-checkradio[type=\"radio\"],\n                .is-checkradio[type=\"checkbox\"] {\n                  outline: 0;\n                  user-select: none;\n                  display: inline-block;\n                  position: absolute;\n                  opacity: 0;\n                }\n              }\n            }\n \n            .questionnarieAns {\n              padding: 2rem 0rem;\n              margin-top: -7%;\n            }\n \n            .switch[type=\"checkbox\"] {\n              outline: 0;\n              user-select: none;\n              display: inline-block;\n              position: absolute;\n              opacity: 0;\n            }\n \n            .switch[type=\"checkbox\"].is-small+label {\n              position: relative;\n              display: initial;\n              font-size: 1rem;\n              line-height: initial;\n              padding-left: 0;\n              padding-right: 3.5rem;\n              cursor: pointer;\n              font-weight: normal;\n            }\n \n            .switch[type=\"checkbox\"].is-success:checked+label::before,\n            .switch[type=\"checkbox\"].is-success:checked+label:before {\n              background: var(--primaryColor);\n            }\n \n            .switch[type=\"checkbox\"].is-sucess+label::before,\n            .switch[type=\"checkbox\"].is-success+label:before {\n              left: auto;\n              right: -0.375rem;\n            }\n \n            .switch[type=\"checkbox\"]+label::before,\n            .switch[type=\"checkbox\"]+label:before {\n              position: absolute;\n              display: block;\n              top: 0;\n              left: auto;\n              right: 0.25rem;\n              width: 3rem;\n              height: 1.5rem;\n              border: 0.1rem solid transparent;\n              border-radius: 4px;\n              background: #b5b5b5;\n              content: \"\";\n            }\n \n            // .switch[type=\"checkbox\"].is-success+label::after, .switch[type=\"checkbox\"].is-success+label:after {\n            //   left: auto;\n            //   right: .25rem;\n            // }\n \n            .switch[type=\"checkbox\"].is-success+label::after,\n            .switch[type=\"checkbox\"].is-success+label:after {\n              display: block;\n              position: absolute;\n              top: 0.25rem;\n              left: auto;\n              right: 1.425rem;\n              width: 1rem;\n              height: 1rem;\n              transform: translate3d(0, 0, 0);\n              border-radius: 4px;\n              background: var(--whiteColor);\n              transition: all 0.25s ease-out;\n              content: \"\";\n            }\n \n            .switch[type=\"checkbox\"]:checked.is-success+label::after,\n            .switch[type=\"checkbox\"]:checked.is-success+label:after {\n              left: auto;\n              right: 0;\n            }\n          }\n \n          .card-footer {\n            .lessonPublish {\n              width: 100% !important;\n              margin-left: 26px;\n \n              .responsiveRadioBtn {\n                margin: 20px 0;\n              }\n \n              .switch[type=\"checkbox\"]+label {\n                position: relative;\n                display: initial;\n                font-size: 1rem;\n                line-height: initial;\n                padding-left: 0;\n                padding-right: 3.5rem;\n                cursor: pointer;\n                font-weight: bold;\n              }\n \n              .switch[type=\"checkbox\"]+label::before {\n                position: absolute;\n                display: block;\n                top: 0;\n                left: auto;\n                right: -0.375rem;\n                width: 3rem;\n                height: 1.5rem;\n                border: 0.1rem solid transparent;\n                border-radius: 4px;\n                background: #b5b5b5;\n                content: \"\";\n              }\n \n              .switch[type=\"checkbox\"].is-success+label:after {\n                display: block;\n                position: absolute;\n                top: 0.25rem;\n                left: auto;\n                right: 1.425rem;\n                width: 1rem;\n                height: 1rem;\n                transform: translate3d(0, 0, 0);\n                border-radius: 4px;\n                background: var(--whiteColor);\n                transition: all 0.25s ease-out;\n                content: \"\";\n              }\n            }\n \n            .lessonSubmitBtn {\n              position: absolute;\n              top: 5px;\n              right: 0px;\n            }\n \n            .actBtnMobileView {\n              display: none;\n            }\n          }\n \n          .card-header {\n            .card-header-title {\n              font-size: 19px !important;\n            }\n          }\n \n          .buylesson {\n            position: absolute;\n            top: 0px;\n            z-index: 9;\n            height: 50px;\n            display: none;\n            font-size: 15px;\n            bottom: 0px;\n            // opacity: 0.85;\n          }\n        }\n      }\n    }\n \n    .editedFileUpload {\n      .card {\n        .card-content {\n          overflow-y: auto;\n          max-height: calc(100vh - 253px);\n        }\n\n\n        .card-body{\n          padding:1rem !important;\n        }\n      }\n    }\n  }\n\n\n\n\n  .modal-card{\n    width:calc(100% - 20px);\n     \n  }\n  .modal-card-title{\n    font-size:1.2rem;\n  }\n  .modal-content-body{\n    position: relative;\n    margin: 0 auto;\n    max-height:calc(100vh - 40px);\n   // background: #fff;\n    width:calc(100% - 100px);\n     .modal-card-body{\n        max-height: calc(100vh - 200px);\n        overflow: auto;\n        min-height:50vh;\n        background:hsl(0, 0%, 98%) ;\n     }\n  }\n\n\n  .modal-card-head{\n    border-top-left-radius:0px;\n    border-top-right-radius:0px;\n    background: var(--popupwindowheadbg);\n    p{\n      color: #fff;\n    }\n  }\n\n\n  .modal-card-foot {\n    border-bottom-left-radius:0px;\n    border-bottom-right-radius:0px;\n    justify-content: end;\n    min-height:50px;\n    .button.is-link{\n      background: var(--popupwindowheadbg) !important;\n    }\n  }\n\n\n  .policy-upload{\n   \n     #questiontopic::placeholder {\n      color: rgb(182, 182, 182) !important;\n      text-transform: capitalize;\n      font-size:1rem !important;\n    }\n    .tabs{\n     padding:0rem 0rem;\n\n\n        .tab{\n          pointer-events: none;\n          opacity:0.5;\n        }\n\n\n        .tab.is-active{\n          opacity:1;\n          pointer-events: none;\n        }\n    }\n\n\n    .profile-img {\n              width: 100% !important;\n              height:100px !important;\n              img{\n                 width:60px !important;\n                border-radius:0px !important;\n                box-shadow: none !important;\n                min-width:50px !important;\n              }\n              .file-cta{\n                    width: 150px;\n                   height: 100px;\n                  display: flex ;\n                  justify-content: center;\n                   background-color: transparent !important;\n                   color: transparent !important;\n                   border-color: transparent !important;\n                  .file-icon{\n                     justify-content: center;\n                     .fa-solid {\n                      font-size:6rem !important;\n                      color: var(--primaryColor) !important;\n                     }\n                  }\n              }\n            }\n    .modal-dialog{\n        max-width:calc(100vw - 50px) !important;\n        .modal-content{\n            width:100% !important;\n            overflow: hidden;\n        }\n        .modal-body{\n            padding:0px !important;\n         }\n\n\n         ::ng-deep .card{\n            box-shadow: none !important;\n            .card-body{\n                height: calc(100vh - 230px) !important;\n               overflow: auto;\n            }\n        }\n        .modal-footer{\n          border-top:1px solid #dbdbdb;\n        }\n    }\n}\n.modal-dialog{\n    .modal-content{\n        max-width:calc(100vw - 50px);\n    }\n    .modal-header{\n        justify-content: space-between;\n    }\n    .modal-body{\n      // max-height:calc(100vh - 150px);\n      // overflow-y: auto;\n      scrollbar-width: none;\n    }\n    .fa-solid{\n        font-size:1.5rem !important;\n        color:#fff !important;\n    }\n    .btn-primary{\n        background: var(--primaryColor) !important;\n        color:#fff !important;\n    }\n    .btn-cancel{\n        background-color:#eee;\n        color:#111;\n    }\n    .btn{\n        padding:.3rem .8rem !important;\n    }\n}\n.modal.fade{\n    background:rgba(0,0,0,0.2);\n}\n.modal.show{\n    display: block;\n}\n.modal-header{\n    background: var(--primaryColor);\n    color:#fff;\n}\n.summarization-popup{\n  .modal-content{\n    overflow: hidden;\n  }\n  .modal-body{\n    overflow-y: auto;\n  }\n}\n\n\n\n\n::ng-deep .formatted-table {\n                border-collapse: collapse;\n                width: 100%;\n                margin: 20px 0;\n                background: white;\n                border-radius: 8px;\n                overflow: hidden;\n                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n                font-size: 14px;\n            }\n           \n ::ng-deep  .formatted-table th {\n                background: linear-gradient(135deg, #34495e, #2c3e50);\n                color: white;\n                padding: 15px 12px;\n                text-align: left;\n                font-weight: 600;\n                text-transform: uppercase;\n                font-size: 12px;\n                letter-spacing: 0.5px;\n                border: none;\n            }\n           \n::ng-deep .formatted-table td {\n                padding: 12px;\n                border-bottom: 1px solid #ecf0f1;\n                border-right: 1px solid #ecf0f1;\n                vertical-align: top;\n                transition: background-color 0.2s ease;\n            }\n           \n::ng-deep .formatted-table tr:hover td {\n                background-color: #f8f9fa;\n            }\n           \n::ng-deep .formatted-table tr:nth-child(even) td {\n                background-color: #fdfdfd;\n            }\n           \n::ng-deep .formatted-table tr:last-child td {\n                border-bottom: none;\n            }\n           \n::ng-deep .formatted-table td:last-child {\n                border-right: none;\n            }\n           \n            /* Heading Styles */\n::ng-deep .formatted-heading {\n                color: #2c3e50;\n                margin: 25px 0 15px 0;\n                font-weight: 600;\n                position: relative;\n            }\n           \n::ng-deep .formatted-heading.h1 {\n                font-size: 1.5em;\n                border-bottom: 3px solid #3498db;\n                padding-bottom: 10px;\n            }\n           \n::ng-deep .formatted-heading.h2 {\n                font-size: 1.2em;\n                border-bottom: 2px solid #3498db;\n                padding-bottom: 8px;\n            }\n           \n::ng-deep .formatted-heading.h3 {\n                font-size: 1.3em;\n                color: #34495e;\n            }\n           \n::ng-deep  .formatted-heading.h4 {\n                font-size: 1.2em;\n                color: #34495e;\n            }\n           \n::ng-deep .formatted-heading.h5 {\n                font-size: 1.1em;\n                color: #34495e;\n            }\n           \n::ng-deep .formatted-heading.h6 {\n                font-size: 1em;\n                color: #34495e;\n                text-transform: uppercase;\n                letter-spacing: 1px;\n            }\n\n\n  .survey-modal,.poll-modal{\n    .card-content{\n      padding:1rem 1.5rem !important;\n    }\n    .survey-question:first-child,.poll-question:first-child{\n      h3{\n        margin-top:0px !important;\n      }\n    }\n  }\n \n \n   /**************radio button***************/\n  $color1: #f4f4f4;\n$color2: #3197EE;\n.radio-group{\n  width:250px !important;\n}\n.radio {\n  margin: 0.5rem;\n  input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    + .radio-label {\n      a{\n        font-weight: bold;\n      }\n      &:before {\n        content: '';\n        background: $color1;\n        border-radius: 100%;\n        border: 1px solid darken($color1, 25%);\n        display: inline-block;\n        width: 1.4em;\n        height: 1.4em;\n        position: relative;\n        top: -0.1em;\n        margin-right:.5em;\n        vertical-align: top;\n        cursor: pointer;\n        text-align: center;\n        transition: all 250ms ease;\n      }\n    }\n    &:checked {\n      + .radio-label {\n        &:before {\n          background-color: $color2;\n          box-shadow: inset 0 0 0 4px $color1;\n        }\n      }\n    }\n    &:focus {\n      + .radio-label {\n        &:before {\n          outline: none;\n          border-color: $color2;\n        }\n      }\n    }\n    &:disabled {\n      + .radio-label {\n        &:before {\n          box-shadow: inset 0 0 0 4px $color1;\n          border-color: darken($color1, 25%);\n          background: darken($color1, 25%);\n        }\n      }\n    }\n    + .radio-label {\n      &:empty {\n        &:before {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n\n\n  @media screen and (max-width:320px) and (max-width:767px) {\n    .library_tile_view {\n        .flex-container {\n          .flex-item {\n            .card {\n              .card-footer {\n                .actBtnDeskView {\n                  display: none;\n                }\n \n                .actBtnMobileView {\n                  display: block;\n                  float: right;\n                }\n              }\n            }\n          }\n        }\n      }\n\n\n      .library_tile_view {\n        .flex-item {\n          width: 319px;\n \n          .responsiveRadioBtn {\n            margin: 20px 0;\n          }\n \n          .questionnarieMobile {\n            margin-top: 10px;\n          }\n \n          .card {\n            .card-content,.card-body {\n              .questionnarie {\n                .question-option {\n\n\n                  .control {\n                    width: 176px;\n \n                    .is-checkradio[type=\"radio\"].is-danger+label::before,\n                    .is-checkradio[type=\"radio\"].is-danger+label:before {\n                      border: 3px solid #f14668;\n                    }\n                  }\n                }\n              }\n \n              .interactiveScroll {\n                .is-divider-vertical {\n                  display: block;\n                  flex: none;\n                  width: auto;\n                  height: auto;\n                  padding: 2rem;\n                  margin: 0;\n                  position: relative;\n                  border-top: none;\n                  min-height: 2rem;\n \n                  &::before {\n                    border-left: 0.1rem solid #dbdbdb;\n                    bottom: 1rem;\n                    content: \"\";\n                    display: block;\n                    left: 50%;\n                    position: absolute;\n                    top: 1rem;\n                    -webkit-transform: translateX(-50%);\n                    -ms-transform: translateX(-50%);\n                    transform: translateX(-50%);\n                  }\n                }\n              }\n            }\n \n            .card-footer {\n              .lessonPublish {\n                width: 100% !important;\n                margin-left: 26px;\n \n                .responsiveRadioBtn {\n                  margin: 20px 0;\n                }\n \n                .switch[type=\"checkbox\"]+label {\n                  position: relative;\n                  display: initial;\n                  font-size: 1rem;\n                  line-height: initial;\n                  padding-left: 0;\n                  padding-right: 3.5rem;\n                  cursor: pointer;\n                  font-weight: bold;\n                }\n \n                .switch[type=\"checkbox\"]+label::before {\n                  position: absolute;\n                  display: block;\n                  top: 0;\n                  left: auto;\n                  right: -0.375rem;\n                  width: 3rem;\n                  height: 1.5rem;\n                  border: 0.1rem solid transparent;\n                  border-radius: 4px;\n                  background: #b5b5b5;\n                  content: \"\";\n                }\n \n                .switch[type=\"checkbox\"].is-success+label:after {\n                  display: block;\n                  position: absolute;\n                  top: 0.25rem;\n                  left: auto;\n                  right: 1.425rem;\n                  width: 1rem;\n                  height: 1rem;\n                  transform: translate3d(0, 0, 0);\n                  border-radius: 4px;\n                  background: var(--whiteColor);\n                  transition: all 0.25s ease-out;\n                  content: \"\";\n                }\n              }\n \n              .lessonSubmitBtn {\n                position: absolute;\n                top: 5px;\n                right: 0px;\n              }\n            }\n          }\n        }\n      }\n \n \n  }\n\n\n  .elibPlaying-Media .columns .column .card .card-table .content .list-wrapper ul .selectedActive\n \n {\n    background: var(--listbackgoundhover) !important;\n    border-bottom:1px solid var(--listcolor) !important;\n    border-top:1px solid var(--listcolor) !important;\n    .title,.shared{\n      color: var(--listcolor) !important;\n    }\n}\n.content .list-wrapper ul {\n  li{\n   margin-top:0px !important;\n   border-bottom:1px solid #f1f2f5 !important;\n    .title{\n      color: var(--textsecondarycolor) !important;\n    }\n    .shared{\n      color:#999 !important;\n    }\n  }\n  li .is-checkradio[type=checkbox]:checked + label:before{\n  border: 0.1rem solid #0eab72 !important;\n  }\n  li .is-checkradio[type=checkbox]:checked + label:after{\n    border-color: #0eab72 !important;\n  }\n}\n \n\n\n \n \n.list-wrapper li:hover{\n  background: var(--listbackgoundhover) !important;\n   .title,.shared{\n      color: var(--listcolor) !important;\n    }\n}\n\n\n  .lessonSubmitBtn.disabled{\n      pointer-events: none !important;\n  }\n  .assQuestTest{\n    .label{\n      color:#353535 !important;\n    }\n  }\n\n\n  /***********card check box********/\n  .checkbox-wrapper {\n    box-sizing: border-box;\n    --background-color: #fff;\n    --checkbox-height:20px;\n  }\n\n\n  @-moz-keyframes dothabottomcheck-19 {\n    0% {\n      height: 0;\n    }\n    100% {\n      height: calc(var(--checkbox-height) / 2);\n    }\n  }\n\n\n  @-webkit-keyframes dothabottomcheck-19 {\n    0% {\n      height: 0;\n    }\n    100% {\n      height: calc(var(--checkbox-height) / 2);\n    }\n  }\n\n\n  @keyframes dothabottomcheck-19 {\n    0% {\n      height: 0;\n    }\n    100% {\n      height: calc(var(--checkbox-height) / 2);\n    }\n  }\n\n\n  @keyframes dothatopcheck-19 {\n    0% {\n      height: 0;\n    }\n    50% {\n      height: 0;\n    }\n    100% {\n      height: calc(var(--checkbox-height) * 1.2);\n    }\n  }\n\n\n  @-webkit-keyframes dothatopcheck-19 {\n    0% {\n      height: 0;\n    }\n    50% {\n      height: 0;\n    }\n    100% {\n      height: calc(var(--checkbox-height) * 1.2);\n    }\n  }\n\n\n  @-moz-keyframes dothatopcheck-19 {\n    0% {\n      height: 0;\n    }\n    50% {\n      height: 0;\n    }\n    100% {\n      height: calc(var(--checkbox-height) * 1.2);\n    }\n  }\n\n\n  .card-image{\n    .checkbox-wrapper{\n      position: absolute;\n      z-index:1;\n      top:2px;\n      right:2px;\n    }\n  }\n  .checkbox-wrapper input[type=checkbox] {\n    display: none;\n  }\n\n\n  .checkbox-wrapper .check-box {\n    height: var(--checkbox-height);\n    width: var(--checkbox-height);\n    background-color: transparent;\n    border: calc(var(--checkbox-height) * .1) solid #858585;\n    border-radius: 5px;\n    position: relative;\n    display: inline-block;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -moz-transition: border-color ease 0.2s;\n    -o-transition: border-color ease 0.2s;\n    -webkit-transition: border-color ease 0.2s;\n    transition: border-color ease 0.2s;\n    cursor: pointer;\n  }\n  .checkbox-wrapper .check-box::before,\n  .checkbox-wrapper .check-box::after {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    position: absolute;\n    height: 0;\n    width: calc(var(--checkbox-height) * .2);\n    background-color: #34b93d;\n    display: inline-block;\n    -moz-transform-origin: left top;\n    -ms-transform-origin: left top;\n    -o-transform-origin: left top;\n    -webkit-transform-origin: left top;\n    transform-origin: left top;\n    border-radius: 5px;\n    content: \" \";\n    -webkit-transition: opacity ease 0.5;\n    -moz-transition: opacity ease 0.5;\n    transition: opacity ease 0.5;\n  }\n  .checkbox-wrapper .check-box::before {\n    top: calc(var(--checkbox-height) * .72);\n    left: calc(var(--checkbox-height) * .41);\n    box-shadow: 0 0 0 calc(var(--checkbox-height) * .05) var(--background-color);\n    -moz-transform: rotate(-135deg);\n    -ms-transform: rotate(-135deg);\n    -o-transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n    transform: rotate(-135deg);\n  }\n  .checkbox-wrapper .check-box::after {\n    top: calc(var(--checkbox-height) * .37);\n    left: calc(var(--checkbox-height) * .05);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n  }\n\n\n  .checkbox-wrapper input[type=checkbox]:checked + .check-box,\n  .checkbox-wrapper .check-box.checked {\n    border-color: #34b93d;\n  }\n  .checkbox-wrapper input[type=checkbox]:checked + .check-box::after,\n  .checkbox-wrapper .check-box.checked::after {\n    height: calc(var(--checkbox-height) / 2);\n    -moz-animation: dothabottomcheck-19 0.2s ease 0s forwards;\n    -o-animation: dothabottomcheck-19 0.2s ease 0s forwards;\n    -webkit-animation: dothabottomcheck-19 0.2s ease 0s forwards;\n    animation: dothabottomcheck-19 0.2s ease 0s forwards;\n  }\n  .checkbox-wrapper input[type=checkbox]:checked + .check-box::before,\n  .checkbox-wrapper .check-box.checked::before {\n    height: calc(var(--checkbox-height) * 1.2);\n    -moz-animation: dothatopcheck-19 0.4s ease 0s forwards;\n    -o-animation: dothatopcheck-19 0.4s ease 0s forwards;\n    -webkit-animation: dothatopcheck-19 0.4s ease 0s forwards;\n    animation: dothatopcheck-19 0.4s ease 0s forwards;\n  }\n  .close-player-icon{\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n// Publish User Modal - matching more-user-modal design\n.publish-user-modal {\n  .modern-modal {\n    border-radius: 12px;\n    overflow: hidden;\n    background: #fff;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n    max-width: 420px;\n    width: 95%;\n    margin: auto;\n    transition: all 0.3s ease;\n    z-index: 9999;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n\n    @media (min-width: 767px) and (max-width: 956px) {\n      max-width: 500px !important;\n      width: 90% !important;\n      max-height: 92vh !important;\n    }\n\n    @media (max-width: 766px) {\n      max-width: 95%;\n      width: 95%;\n      max-height: 95vh;\n    }\n\n    @media (max-width: 480px) {\n      width: 100%;\n      max-width: 100%;\n      margin: 0;\n      border-radius: 0;\n      max-height: 100vh;\n    }\n  }\n\n  .modern-modal-head {\n    background: linear-gradient(135deg, #1571b9, #4c8dff);\n    color: #fff;\n    padding: 1rem 1.2rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    order: 0;\n\n    .modal-title {\n      font-weight: 600;\n      font-size: 1.1rem;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .delete {\n      background: transparent;\n      color: #fff;\n      opacity: 0.8;\n      transition: 0.2s;\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .modern-modal-body {\n    padding: 1rem 1.2rem;\n    background: #f9fafc;\n    max-height: 60vh;\n    overflow-y: auto;\n    flex: 1;\n\n    @media (min-width: 767px) and (max-width: 956px) {\n      padding: 0.9rem 1.1rem !important;\n      max-height: 62vh !important;\n    }\n\n    @media (max-width: 766px) {\n      padding: 0.75rem 1rem;\n      max-height: 65vh;\n    }\n\n    @media (max-width: 480px) {\n      padding: 0.75rem;\n      max-height: calc(100vh - 200px);\n    }\n\n    .search-container {\n      margin-bottom: 1rem;\n\n      .search-input {\n        border-radius: 8px;\n        border: 1px solid #dcdcdc;\n        transition: 0.2s;\n\n        &:focus {\n          border-color: #1571b9;\n          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n        }\n      }\n\n      .clear-icon {\n        cursor: pointer;\n        color: #999;\n\n        &:hover {\n          color: #333;\n        }\n      }\n    }\n\n    .select-all-container {\n      margin-bottom: 0.75rem;\n      padding-bottom: 0.75rem;\n      border-bottom: 1px solid #e0e0e0;\n\n      .select-all-item {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        border-radius: 8px;\n        padding: 0.75rem;\n        cursor: pointer;\n        transition: all 0.25s ease;\n        min-height: 44px;\n        background: #f5f7fa;\n\n        &:hover {\n          background: #eef5ff;\n        }\n\n        &.active {\n          background: #dceeff;\n          border-left: 3px solid #1571b9;\n        }\n\n        .user-avatar {\n          background: #e8f0fe;\n          border-radius: 50%;\n          width: 38px;\n          height: 38px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n\n        .user-name {\n          flex: 1;\n          font-weight: 600;\n          color: #333;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .check-icon {\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n      }\n    }\n\n    .user-list {\n      .user-item {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        border-radius: 8px;\n        padding: 0.75rem;\n        margin-bottom: 0.5rem;\n        cursor: pointer;\n        transition: all 0.25s ease;\n        min-height: 44px;\n\n        &:hover {\n          background: #eef5ff;\n        }\n\n        &.active {\n          background: #dceeff;\n          border-left: 3px solid #1571b9;\n        }\n\n        .user-avatar {\n          background: #e8f0fe;\n          border-radius: 50%;\n          width: 38px;\n          height: 38px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n\n        .user-name {\n          flex: 1;\n          color: #333;\n          font-weight: 500;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        .check-icon {\n          color: #1571b9;\n          font-size: 1.2rem;\n          flex-shrink: 0;\n        }\n      }\n    }\n  }\n\n  .modern-modal-foot {\n    padding: 1rem 1.2rem;\n    background: #fff;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.75rem;\n    order: 2;\n\n    .clear-btn {\n      background: #f5f7fa;\n      color: #666;\n      border: 1px solid #ddd;\n      padding: 0.6rem 1rem;\n      border-radius: 8px;\n      font-weight: 500;\n      transition: all 0.2s;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n\n      &:hover {\n        background: #eef5ff;\n        border-color: #1571b9;\n        color: #1571b9;\n      }\n    }\n\n    .button-group {\n      display: flex;\n      gap: 0.75rem;\n\n      .cancel-btn {\n        background: #fff;\n        color: #666;\n        border: 1px solid #ddd;\n        padding: 0.6rem 1.2rem;\n        border-radius: 8px;\n        font-weight: 500;\n        transition: all 0.2s;\n\n        &:hover {\n          background: #f5f7fa;\n          border-color: #999;\n        }\n      }\n\n      .publish-btn {\n        background: linear-gradient(135deg, #1571b9, #4c8dff);\n        color: #fff;\n        border: none;\n        padding: 0.6rem 1.2rem;\n        border-radius: 8px;\n        font-weight: 500;\n        transition: all 0.2s;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n\n        &:hover:not(:disabled) {\n          background: linear-gradient(135deg, #0f5a9a, #3a7ae8);\n          transform: translateY(-1px);\n          box-shadow: 0 4px 8px rgba(21, 113, 185, 0.3);\n        }\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
